import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, CheckCircle2, Mail } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading"); // loading | done | error
  const [email, setEmail] = useState("");
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/public/unsubscribe", { token })
      .then((r) => { setEmail(r.data.email || ""); setState("done"); })
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#faf8f3] px-4" data-testid="unsubscribe-page">
      <div className="w-full max-w-md rounded-3xl border border-zinc-200 bg-white p-8 text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-600 text-white">
          {state === "loading" ? <Loader2 className="h-6 w-6 animate-spin" /> : state === "done" ? <CheckCircle2 className="h-6 w-6" /> : <Mail className="h-6 w-6" />}
        </div>
        {state === "loading" && <p className="mt-4 text-zinc-600">Updating your preferences…</p>}
        {state === "done" && (<>
          <h1 className="mt-4 font-display text-2xl font-bold text-zinc-900">You're unsubscribed</h1>
          <p className="mt-2 text-sm text-zinc-600">{email ? `${email} ` : "You "}won't receive promotional emails from Nearfluence. Essential account and collaboration emails will still be sent.</p>
        </>)}
        {state === "error" && (<>
          <h1 className="mt-4 font-display text-2xl font-bold text-zinc-900">Link not valid</h1>
          <p className="mt-2 text-sm text-zinc-600">This unsubscribe link is invalid or has expired. You can manage email preferences in your account settings.</p>
        </>)}
        <Link to="/" className="mt-6 inline-block text-sm font-semibold text-emerald-700 hover:underline">Back to Nearfluence</Link>
      </div>
    </div>
  );
}
